import CampaignFormPopup from '../views/campaign-form-popup';
import ContactForm from '../views/contact-form';
import ContactPrefs from '../views/contact-prefs';
import ContentPrefs from '../views/content-prefs';
import FleetForm from '../views/fleet-form';
import FollowUp from '../views/follow-up';
import Newsletter from '../views/newsletter-form';
import NewsletterPopup from '../views/newsletter-form-popup';
import ReserveMySeat from '../views/reserve-my-seat';
import ReserveMySeatVIP from '../views/reserve-my-seat-vip';
import Subscribe from '../views/subscribe-form';
import {Success} from '../views/success';
import Unsubscription from '../views/unsubscription';
import type {IViewConfig, VariantType, ViewTypes} from './types';

export const VariantMapping: {[k in VariantType]: [ViewTypes, ...ViewTypes[]]} =
  {
    // keep the default view in the first positions of the array
    contact: [`contact-form`, `success`],
    newsletter: [
      `newsletter-form`,
      `follow-up`,
      `contact-prefs`,
      `content-prefs`,
      `success`,
    ],
    newsletter_popup: [`newsletter-form-popup`],
    reservemyseat: [
      `reserve-my-seat`,
      `follow-up`,
      `contact-prefs`,
      `contact-prefs`,
      `success`,
    ],
    reservemyseat_vip: [`reserve-my-seat-vip`, `success`],
    unsubscription: [`unsubscription`, `success`],
    fleet: [`fleet-form`, `success`],
    subscribe: [`subscribe-form`],
    subscribe_popup: [`subscribe-form-popup`],
    campaign_popup: [`campaign-form-popup`],
  };

export const availableViewsConfigs: {[t in ViewTypes]: IViewConfig} = {
  'contact-form': {component: ContactForm, tokenRequired: `new`},
  'newsletter-form': {component: Newsletter, tokenRequired: `new`},
  'newsletter-form-popup': {
    component: NewsletterPopup,
    tokenRequired: `new`,
  },
  'reserve-my-seat': {component: ReserveMySeat, tokenRequired: `new`},
  'follow-up': {component: FollowUp, tokenRequired: `required`},
  'contact-prefs': {component: ContactPrefs, tokenRequired: `required`},
  'content-prefs': {component: ContentPrefs, tokenRequired: `required`},
  'reserve-my-seat-vip': {component: ReserveMySeatVIP, tokenRequired: `new`},
  'unsubscription': {component: Unsubscription, tokenRequired: `new`},
  'success': {component: Success, tokenRequired: `new`},
  'fleet-form': {component: FleetForm, tokenRequired: `new`},
  'subscribe-form': {component: Subscribe, tokenRequired: `new`},
  'subscribe-form-popup': {
    component: () => Subscribe({renderAsPopup: true}),
    tokenRequired: `new`,
  },
  'campaign-form-popup': {
    component: CampaignFormPopup,
    tokenRequired: `new`,
  },
};
